import { useTranslation } from 'react-i18next'
import Select from 'react-select'

interface LanguageSwitcherProps {
  className?: string
}

const LanguageSwitcher = (props: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation('common')

  return (
    <Select
      id="language-switcher"
      defaultValue={{ label: '🇬🇧 EN', value: 'en' }}
      options={[
        { label: '🇬🇧 EN', value: 'en' },
        { label: '🇫🇷 FR', value: 'fr' },
      ]}
      onChange={(option) => {
        void i18n.changeLanguage(option.value)
      }}
      components={{ IndicatorSeparator: () => null }}
      isSearchable={false}
      classNames={{
        control: () => 'language-switcher__control',
        singleValue: () => `${props.className}`,
        dropdownIndicator: () => 'language-switcher__dropdown-indicator',
        valueContainer: () => 'language-switcher__value-container',
        option: ({ isSelected, isFocused }) =>
          `language-switcher__option ${isSelected ? 'is-selected' : ''} ${isFocused ? 'is-focused' : ''}`,
      }}
    />
  )
}

export default LanguageSwitcher
